import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpStatus } from '../../common/enums/HttpStatus';
import { INotification } from '../../common/interfaces/NotificationConfiguration.interface';
import { createBaseQuery } from './utils/createBaseQuery';

export const notificationConfigurationsApi = createApi({
  reducerPath: 'NotificationConfigurationsApi',
  baseQuery: createBaseQuery('/notification-configurations'),
  tagTypes: ['NotificationConfigurations'],
  endpoints: (builder) => ({
    fetchNotificationConfiguration: builder.query<
      { code: HttpStatus; data: INotification[] },
      { page: number; size: number }
    >({
      query: ({ page, size }) => `?page=${page}&size=${size}`,
      providesTags: (result) =>
        result
          ? [
              { type: 'NotificationConfigurations' as const, id: 'LIST' },
              ...result.data.map(({ id }) => ({
                type: 'NotificationConfigurations' as const,
                id,
              })),
            ]
          : [{ type: 'NotificationConfigurations' as const, id: 'LIST' }],
    }),
    updateNotification: builder.mutation<
      INotification,
      { id: string; updatedNotification: INotification }
    >({
      query: ({ id, updatedNotification }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: { ...updatedNotification },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'NotificationConfigurations', id },
        { type: 'NotificationConfigurations', id: 'LIST' },
      ],
    }),
    createNotification: builder.mutation<INotification, Partial<INotification>>(
      {
        query: (updatedNotification) => ({
          url: '',
          method: 'POST',
          body: updatedNotification,
        }),
        invalidatesTags: [{ type: 'NotificationConfigurations', id: 'LIST' }],
      }
    ),
  }),
});

export const {
  useFetchNotificationConfigurationQuery,
  useUpdateNotificationMutation,
  useCreateNotificationMutation,
} = notificationConfigurationsApi;
